<template>
  <app-layout>
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        学校管理 登録タスク一覧
      </h2>
    </template>

    <div class="flex justify-left pl-12 pt-4 my-2">
      <a
        class="py-2 px-6 bg-blue-600 hover:shadow-lg text-white rounded"
        :href="route('usersRegistration')">登録画面へ</a>
    </div>

    <div
      v-if="!userRegistrationTask.length"
      class="text-center">
      タスクはありません。
    </div>
    <div
      v-else
      class="py-4 flex flex-col items-center">
      <div class="shadow w-11/12 overflow-x-auto overflow-y-auto border-b border-gray-200 sm:rounded-lg">
        <table class="w-full table-auto divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th
                scope="col"
                class="px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider">
                ID
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider">
                学校名
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider">
                CSVファイル名
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider">
                ステータス
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider">
                処理したユーザ数
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider">
                登録実行日時
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-center font-medium text-gray-500 uppercase tracking-wider">
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(item, i) in userRegistrationTask"
            :key="i"
            class="bg-white divide-y divide-gray-200">
            <tr>
              <td class="px-6 py-4 whitespace-nowrap">
                <div class="flex items-center">
                  <div class="text-gray-900">
                    {{ item.id }}
                  </div>
                </div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-center">
                <div class="text-gray-900">
                  {{ getSchoolName(item.school_id) ?? '一般ユーザ' }}
                </div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-center">
                <span class="text-gray-900">
                  {{ item.csv_file_name }}
                </span>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-center">
                <span class="px-2 inline-flex leading-5 rounded-full text-gray-900">
                  {{ item.status == 1 ? '処理中' : '完了' }}
                </span>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-center">
                <span class="px-2 inline-flex leading-5 rounded-full text-gray-900">
                  {{ item.complete_users_num }} / {{ item.users_num }}
                </span>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-center">
                <span class="px-2 inline-flex leading-5 rounded-full text-gray-900">
                  {{ formatDate(item.created_at) }}
                </span>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                <a
                  class="py-2 px-6 text-blue-600"
                  :href="route('usersRegistration.task.show', { 'userRegistrationTask': item.id })">登録タスク一覧</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </app-layout>
</template>

<script setup>
import moment from 'moment'
import formatDate from '@/actions/format/date'
import AppLayout from '@/Layouts/AppLayout.vue'

const props = defineProps({
  schools: {
    type: Array,
    default: () => [],
  },
  userRegistrationTask: {
    type: Array,
    default: () => [],
  },
})

const getSchoolName = (id) => props.schools.find(e => e.id == id)?.name

</script>
